import React, { useEffect, useState } from "react";
import "./nav.css";
import logo from "../../assets/logo.png";
import {
  CloseCircle,
  // Document,
  DocumentFavorite,
  HambergerMenu,
  Home,
  // LogoutCurve,
  Setting,
  // Wallet,
} from "iconsax-react";
import { Link, useLocation, useNavigate } from "react-router";
import { getFirstString } from "../../utils/utils";

const SideNav = () => {
  const navigate = useNavigate();
  const pathname = useLocation().pathname;

  const [active, setActive] = useState("Overview");
  const [isMenu, setIsMenu] = useState(false);

  const clickLink = (item) => {
    navigate(item.link);
    setIsMenu(false);
    if(item.title === "Log out"){
      localStorage.clear();
      navigate("/auth/signin");
    }
  };
  const clickMenu = () => {
    setIsMenu(!isMenu);
  };

  useEffect(() => {
    setActive(pathname);
  }, [pathname]);


  const sideLinks = [
    {
      title: "overview",
      link: "/agent/overview",
      icon: <Home color="black" size={24} />,
      iconActive: <Home color="#F08224" size={24} />,
    },
    // {
    //   title: "payment",
    //   link: "/agent/payment",
    //   icon: <Wallet color="black" size={24} />,
    //   iconActive: <Wallet color="#F08224" size={24} />,
    // },
    // {
    //   title: "agreement",
    //   link: "/agent/agreement",
    //   icon: <Document color="black" size={24} />,
    //   iconActive: <Document color="#F08224" size={24} />,
    // },
    {
      title: "property",
      link: "/agent/property",
      icon: <DocumentFavorite color="black" size={24} />,
      iconActive: <DocumentFavorite color="#F08224" size={24} />,
    },
    {
      title: "settings",
      link: "/agent/settings",
      icon: <Setting color="black" size={24} />,
      iconActive: <Setting color="#F08224" size={24} />,
    },
    // {
    //   title: "Log out",
    //   icon: <LogoutCurve color="#F08224" size={24} />,
    // },
  ];


  return (
    <>
      <div className="side-nav">
        <div className="side-img">
          <Link to="/" style={{textDecoration: "none"}}><img src={logo} alt="logo" /></Link>
        </div>
        <div className="side-nav_links">
          {sideLinks.map((item, i) => {
            return (
              <div
                key={i}
                className={
                  active.includes(getFirstString(item.title))
                    ? "each-side active-side"
                    : "each-side"
                }
                onClick={() => clickLink(item)}
              >
                {active.includes(getFirstString(item.title))
                  ? item.iconActive
                  : item.icon}
                <p style={{ color: item.title === "Log out" && "#F08224"}}>{item.title}</p>
              </div>
            );
          })}
        </div>
      </div>
      <div className="mobile-side_nav">
        <div className="open-div">
          <HambergerMenu color="#475467" size={24} onClick={clickMenu} />
        </div>
        {isMenu && <div className="side-nav-menu">
          <div className="side-img_mobile">
            <img src={logo} alt="logo" />
            <CloseCircle size={24} color="#475467" onClick={clickMenu} />
          </div>
          <div className="side-nav_links">
            {sideLinks.map((item, i) => {
              return (
                <div
                  key={i}
                  className={
                    active.includes(getFirstString(item.title))
                      ? "each-side active-side"
                      : "each-side"
                  }
                  onClick={() => clickLink(item)}
                  style={{padding: item.title === "Log out" && "40px 20px"}}
                >
                  {active.includes(getFirstString(item.title))
                    ? item.iconActive
                    : item.icon}
                  <p style={{ color: item.title === "Log out" && "#F08224"}}>{item.title}</p>
                </div>
              );
            })}
          </div>
        </div>}
      </div>
    </>
  );
};

export default SideNav;
